import { render, staticRenderFns } from "./ISAForgotPassword.vue?vue&type=template&id=544b211a&scoped=true&"
import script from "./ISAForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ISAForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ISAForgotPassword.vue?vue&type=style&index=0&id=544b211a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b211a",
  null
  
)

export default component.exports